import axios from "axios";
import { env } from "../config/env";

/**
 * Helper to retrieve cookie value by name
 */
function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
  return match ? decodeURIComponent(match[3]) : null;
}

/**
 * Axios instance configured with credential cookies and automatic token / CSRF attachment
 */
export const api = axios.create({
  baseURL: env.API_BASE_URL,
  timeout: 15000,
  withCredentials: true,
});

/**
 * REQUEST INTERCEPTOR
 * Automatically attach JWT token and CSRF double-submit token
 */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Attach CSRF protection token for state-changing requests
    const csrfToken = getCookie("tx_csrf_token");
    if (csrfToken) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * RESPONSE INTERCEPTOR
 * Auto logout on 401 / invalid token
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("JWT expired or session revoked. Logging out.");

      localStorage.removeItem("access_token");
      localStorage.removeItem("role");

      // Redirect safely
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);
